// extracted by mini-css-extract-plugin
export default {"Tag":"tag_Tag__UHnJJ"};